<template>
  <div class="open-platform">
    <div class="nav-toast fixed">
      <a href="/union/homePage/overview/list.htm">首页</a>
      <a href="/openPlatform/index.html">开放平台</a>
      <em>API文档</em>
    </div>
    <div class="sn-content up-fixed q-api">
      <div
        v-for="(item, index) in listData"
        :class="[index ? 'mt20' : '', 'q-ctn', 'un-box-shadow']"
        :key="index"
      >
        <div class="q-header">
          <a
            target="_blank"
            :href="item.title.linkUrl"
          ><span class="sn-btn-orange">{{item.title.elementName}}</span></a>
        </div>
        <div class="q-content">
          <p>{{item.desc.elementName}}</p>
          <ul>
            <li
              v-for="itemy in item.children"
              :key="itemy.trickPoint"
            >
              {{itemy.elementName}}<a
                target="_blank"
                :href="itemy.linkUrl"
              >{{itemy.elementDesc}}</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { opensums } from "@/service";
export default {
  name: "Home",
  data() {
    return {
      listData: []
    };
  },
  created() {
    let self = this;
    opensums()
      .then(res => {
        self.listData = res.map(item => {
          let tag = item.sumspcopen_wenzi.tag;
          return {
            title: tag[0],
            desc: tag[1],
            children: tag.slice(2)
          };
        });
      })
      .catch(error => console.log(error));
  },
};
</script>
<style lang="scss">
@import "./index";
</style>